import React from 'react';
import { Link } from 'react-router-dom';
import { useAppContext } from '../App';
import styles from './AboutPage.module.css';

// Simple markdown-like parser
function parseContent(content: string): React.ReactNode[] {
  const lines = content.split('\n');
  const elements: React.ReactNode[] = [];
  let currentList: string[] = [];
  let inList = false;

  const flushList = () => {
    if (currentList.length > 0) {
      elements.push(
        <ul key={`list-${elements.length}`} className={styles.list}>
          {currentList.map((item, i) => (
            <li key={i}>{parseInline(item)}</li>
          ))}
        </ul>
      );
      currentList = [];
      inList = false;
    }
  };

  const parseInline = (text: string): React.ReactNode => {
    const parts = text.split(/\*\*(.*?)\*\*/g);
    return parts.map((part, i) => 
      i % 2 === 1 ? <strong key={i}>{part}</strong> : part
    );
  };

  lines.forEach((line, index) => {
    const trimmed = line.trim();

    if (trimmed.startsWith('### ')) {
      flushList();
      elements.push(<h3 key={index} className={styles.h3}>{trimmed.slice(4)}</h3>);
    } else if (trimmed.startsWith('## ')) {
      flushList();
      elements.push(<h2 key={index} className={styles.h2}>{trimmed.slice(3)}</h2>);
    } else if (trimmed.startsWith('# ')) {
      flushList();
      elements.push(<h1 key={index} className={styles.h1}>{trimmed.slice(2)}</h1>);
    } else if (trimmed.startsWith('- ')) {
      inList = true;
      currentList.push(trimmed.slice(2));
    } else if (/^\d+\.\s/.test(trimmed)) {
      if (!inList) {
        flushList();
        inList = true;
      }
      currentList.push(trimmed.replace(/^\d+\.\s/, ''));
    } else if (trimmed.startsWith('*') && trimmed.endsWith('*') && !trimmed.startsWith('**')) {
      flushList();
      elements.push(<p key={index} className={styles.italic}>{trimmed.slice(1, -1)}</p>);
    } else if (trimmed.length > 0) {
      flushList();
      elements.push(<p key={index} className={styles.paragraph}>{parseInline(trimmed)}</p>);
    } else {
      flushList();
    }
  });

  flushList();
  return elements;
}

const TermsPage: React.FC = () => {
  const { settings } = useAppContext();

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <Link to="/mission" className={styles.backLink}>← Back to Mission</Link>
        
        <div className={styles.header}>
          <span className={styles.icon}>📜</span>
          <h1>Terms of Use</h1>
        </div>

        <div className={styles.body}>
          {parseContent(settings.termsContent)}
        </div>

        <div className={styles.contact}>
          <h3>Contact Us</h3>
          <p>
            <strong>{settings.contactName}</strong><br />
            <a href={`mailto:${settings.contactEmail}`}>{settings.contactEmail}</a>
          </p>
        </div>

        <div className={styles.footer}>
          <p>© {new Date().getFullYear()} {settings.logoText || 'Pin the Poo'}</p>
        </div>
      </div>
    </div>
  );
};

export default TermsPage;
